export default __webpack_public_path__ + "static/media/exit.c6559479.svg";